
import SignInForm from '@/components/auth/SignInForm';

const SignInPage = () => {
  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-muted/40">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold">Founders CRM</h1>
          <p className="text-muted-foreground mt-2">
            Your complete founder management solution
          </p>
        </div>
        <SignInForm />
      </div>
    </div>
  );
};

export default SignInPage;
